export const colorStyle = {
  color: [
    'interpolate',
    ['linear'],
    ['*', ['band', 1], 16],
    0.0,
    [255, 255, 255, 0],
    0.5,
    [255, 245, 214, 1],
    1.0,
    [245, 200, 0, 1],
    2.0,
    [240, 112, 32, 1],
    5.0,
    [200, 32, 40, 1],
    8.0,
    [104, 56, 184, 1],
  ],
};
